export type UploadStrategy = 'presigned-url' | 'form-data';

export interface IUploadResult {
  publicUrl: string;
  uploadUrl: string;
}

export interface IUploadUrlData {
  uploadUrl: string;
  publicUrl: string;
  headers: Record<string, string | undefined>;
}

export interface IFileUploadParams {
  fileName: string;
  mimeType: string;
}

export interface IPresignedUrlConfig {
  strategy: 'presigned-url';
  getUploadUrlData: (data: IFileUploadParams) => Promise<IUploadUrlData>;
  defaultPreviewImage?: string;
}

export interface IUploadUrlResponse {
  url: string;
}

export interface IFormDataConfig {
  strategy: 'form-data';
  getUploadUrl: (type?: string) => Promise<IUploadUrlResponse>;
  hashFileName?: (fileName: string) => string;
  defaultPreviewImage?: string;
}

export type IFileUploadConfig = IPresignedUrlConfig | IFormDataConfig;

export interface IFrameRequest {
  thumbnail: string;
  width: number;
  height: number;
  duration: number;
}

export function isPresignedUrlConfig(config: IFileUploadConfig): config is IPresignedUrlConfig {
  return config.strategy === 'presigned-url';
}

export function isFormDataConfig(config: IFileUploadConfig): config is IFormDataConfig {
  return config.strategy === 'form-data';
}

export enum HttpErrorCode {
  BadRequest = 400,
  Unauthorized = 401,
  PaymentRequired = 402,
  Forbidden = 403,
  NotFound = 404,
  ContentTooLarge = 413,
  UnknownError = 600,
}
